<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>William Pullar is the pseudonym of a long-retired, Scottish-born national newspaper journalist. He covered many high-profile court cases and took part in several major investigations leading to convictions.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?2c1d0c80